
import Header from '../../components/feature/Header';

export default function Contact() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Contact Section */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold mb-6">聯絡我們</h1>
            <p className="text-blue-100 text-lg mb-8">
              有工程需求或想了解更多服務內容？歡迎與我們聯繫
            </p>
            
            <div className="grid md:grid-cols-3 gap-8 mb-8">
              <div className="text-center">
                <div className="bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <h3 className="font-semibold mb-2">電話聯絡</h3>
                <p className="text-blue-100">0989964485</p>
              </div>
              
              <div className="text-center">
                <div className="bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <h3 className="font-semibold mb-2">電子信箱</h3>
                <p className="text-blue-100">nero.nero@msa.hinet.net</p>
              </div>
              
              <div className="text-center">
                <div className="bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-2xl"></i>
                </div>
                <h3 className="font-semibold mb-2">公司地址</h3>
                <p className="text-blue-100">屏東縣高樹鄉田子村平安巷1-2號1樓</p>
              </div>
            </div>
            
            <a 
              href="mailto:nero.nero@msa.hinet.net" 
              className="inline-flex items-center bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              立即聯絡我們
            </a>
          </div>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-800 mb-4">公司資訊</h2>
              <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">基本資料</h3>
                  <div className="space-y-3">
                    <div className="flex items-center">
                      <i className="ri-building-line text-blue-600 mr-3"></i>
                      <span className="text-gray-700">和明營造有限公司</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-user-line text-blue-600 mr-3"></i>
                      <span className="text-gray-700">負責人：葉芷玲</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-file-text-line text-blue-600 mr-3"></i>
                      <span className="text-gray-700">統一編號：13144873</span>
                    </div>
                  </div>
                </div>
                
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4">聯絡方式</h3>
                  <div className="space-y-3">
                    <div className="flex items-center">
                      <i className="ri-phone-line text-blue-600 mr-3"></i>
                      <span className="text-gray-700">0989964485</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-mail-line text-blue-600 mr-3"></i>
                      <span className="text-gray-700">nero.nero@msa.hinet.net</span>
                    </div>
                    <div className="flex items-start">
                      <i className="ri-map-pin-line text-blue-600 mr-3 mt-1"></i>
                      <span className="text-gray-700">屏東縣高樹鄉田子村平安巷1-2號1樓</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "Pacifico, serif" }}>和明營造有限公司</h3>
            <p className="text-gray-400 mb-4">負責人：葉芷玲 | 統一編號：13144873</p>
            <p className="text-gray-400 text-sm">
              © 2024 和明營造有限公司. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="text-blue-400 hover:text-blue-300 ml-1 cursor-pointer">Website Builder</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
